import React from "react";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";

export const PacasSecadoraDetalle = ({ detalle }) => {
    const { pacasSecadora, hayPacasEnSecadora, pesoPacasSecadora } = detalle;

    const cardClassName = "my-3 p-3 border-gray rounded-xl gap-1rem";

    if (!hayPacasEnSecadora) {
        return (
            <div className={`${cardClassName} align-items-center`}>
                <div className="d-flex align-items-center gap-1rem justify-content-end">
                    <h5 className="mb-1 text-right text-nowrap">
                        ¿Hay pacas en secadora?
                    </h5>
                    <div style={{ minWidth: "200px" }}>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value="No"
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`formulario-fields-column ${cardClassName}`}>
            <h5 className="mb-1">Pacas en secadora</h5>

            <div className="formulario-fields-row gap-1rem my-0">
                <div className="formulario-field">
                    <label className="text-nowrap">
                        ¿Hay pacas en secadora?
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value="Sí"
                    />
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Producto</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={pacasSecadora.producto_nombre || ""}
                    />
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Cantidad aprox.</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={pacasSecadora.cantidad || 0}
                    />
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">
                        Peso de cantidad aprox. de pacas en secadora
                    </label>
                    <RenderKilogramo
                        className="form-control disabled-input"
                        value={pesoPacasSecadora}
                    />
                </div>
            </div>
        </div>
    );
};
